var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 8.5,
    stroke: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5821_9137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.005 7C10.591 7 7 10.591 7 15.005C7 19.4189 10.591 23.01 15.005 23.01C19.419 23.01 23.01 19.4189 23.01 15.005C23.01 10.591 19.419 7 15.005 7ZM15.005 21.5545C11.3936 21.5545 8.45545 18.6164 8.45545 15.005C8.45545 11.3936 11.3936 8.45545 15.005 8.45545C18.6164 8.45545 21.5545 11.3936 21.5545 15.005C21.5545 18.6164 18.6164 21.5545 15.005 21.5545Z",
    fill: "#3E8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2704 13.1704L15.734 14.7067V10.6418C15.734 10.2398 15.4082 9.91406 15.0063 9.91406C14.6044 9.91406 14.2785 10.2398 14.2785 10.6418V14.7067L12.7423 13.1704C12.4581 12.8863 11.9974 12.8863 11.7132 13.1704C11.4289 13.4547 11.4289 13.9154 11.7132 14.1996L14.4917 16.9781C14.6338 17.1203 14.82 17.1913 15.0062 17.1913C15.1924 17.1913 15.3787 17.1203 15.5208 16.9782L18.2995 14.1997C18.5837 13.9155 18.5837 13.4547 18.2996 13.1704C18.0153 12.8863 17.5546 12.8863 17.2704 13.1704Z",
    fill: "#3E8080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4589 18.6406H13.548C13.1461 18.6406 12.8203 18.9664 12.8203 19.3684C12.8203 19.7702 13.1461 20.0961 13.548 20.0961H16.4589C16.8608 20.0961 17.1867 19.7702 17.1867 19.3684C17.1867 18.9664 16.8608 18.6406 16.4589 18.6406Z",
    fill: "#3E8080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5821_9137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.01,
    height: 16.01,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.853d12f58b846884b756672270817755.svg";
export { ForwardRef as ReactComponent };